module.exports = __webpack_public_path__ + "Roboto-Regular.30799efa5bf74129468a.eot";


//////////////////
// WEBPACK FOOTER
// C:/Users/Ludo.DESKTOP-F1GO0J2/PhpstormProjects/orderApi/orderApp/~/angular-bootstrap-md/font/roboto/Roboto-Regular.eot
// module id = ../../../../angular-bootstrap-md/font/roboto/Roboto-Regular.eot
// module chunks = 3